import isEmail from 'utilities/validateEmail';
import isSSN from 'utilities/validateSSN';
import isSIN from 'utilities/validateSIN';

export default (idType = 'ssn', acceptShort = false) => ({
  required: 'Missing input',
  validate: value => {
    if (
      acceptShort &&
      (idType === 'ssn' || idType === 'sin') &&
      value.length <= 4
    ) {
      return (
        value.match(/^\d{4}$/) ||
        `Please enter a full ${idType.toUpperCase()} or the last 4 digits.`
      );
    }
    if (idType === 'ssn') return isSSN(value) || `Please enter a full SSN`;
    if (idType === 'sin') return isSIN(value) || `Please enter a full SIN`;
    if (idType === 'email')
      return isEmail(value) || 'Please enter a valid email.';
  },
});
